import vue from '@/main'

import axios from "../../axios"
import store from "../../store/store"

axios.interceptors.request.use(
  config => {
    vue.$vs.loading({
        type: 'radius',
        text: config.url === 'file/upload' ? 'Carregando Arquivo...' : ''
    });

    if(config.url.includes("file/")){
      config.baseURL = process.env.VUE_APP_API_BASE_URL + "api/";
    }

    // Do something before request is sent
    const accessToken = localStorage.getItem('accessToken')
    if (accessToken) {
      config.headers['Authorization'] = 'Bearer ' + accessToken
    }

    return config
  },
  error => {
    Promise.reject(error)
  })

axios.interceptors.response.use(
  response => {
    vue.$vs.loading.close()
    return response
  },
  async error => {
    vue.$vs.loading.close()
    const { config, response } = error
    const originalRequest = config
    let responseErrors = []

    if (response && response.status === 401) {
      if (response.data.errors) {
        responseErrors = response.data.errors
      } else if (response.data.message) {
        responseErrors = [
          { message: response.data.message }
        ]
      }

      for (const error of responseErrors) {
        if (error.message === 'Token has expired') {
          const accessToken = await store.dispatch("auth/refreshAccessToken")
          originalRequest.headers.Authorization = 'Bearer ' + accessToken

          return Promise.resolve(axios(originalRequest))
        }

        if (error.message === 'Unauthorized') {
          localStorage.removeItem("accessToken")
          return vue.$router.push('/login')
        }
      }
    }

    vue.$vs.notify({
      title: 'Algo está errado.',
      text: responseErrors[0].message,
      iconPack: 'feather',
      icon: 'icon-alert-circle',
      color: 'danger'
    })

    return Promise.reject(error)
  })

export default axios
